import { useCallback } from 'react'

const useWindow = () => {
    const getWindowDomain = useCallback(
        () => `https://${window.location.href.split('/')[2]}`,
        [window.location.href]
    )

    const getWindowURL = useCallback(() => window.location.href, [
        window.location.href,
    ])

    const getWindowQuery = useCallback(
        () => window.location.href.split('?')[1],
        [window.location.href]
    )

    return { getWindowDomain, getWindowQuery, getWindowURL }
}

export default useWindow
